import { useGetCatalogsQuery } from 'Services/ProductManagement/Features/Catalog/catalogApi'
import type { FetchCatalogListParams } from 'Services/ProductManagement/Features/Catalog/types'
import { TariffContext } from 'Services/ProductManagement/Features/Tariff/Context/tariffContext'
import { ROWS_PER_PAGE_DEFAULT, SORT_ORDER_ASC } from 'Util/constants'
import { useContext, useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

export const SELECTED_CATALOG_PARAMETER_KEY = 'selectedCatalog'

function useCatalogsWithParams() {
  const { selectedTariffId } = useContext(TariffContext)
  const [searchParams, setSearchParams] = useSearchParams()

  const [searchQueryParams, setSearchQueryParams] = useState<FetchCatalogListParams>({
    filter: searchParams.get('filter') ?? undefined,
    search_text: searchParams.get('search_text') ?? undefined,
    sort_by: searchParams.get('sort_by') ?? 'name',
    sort_order: searchParams.get('sort_order') ?? SORT_ORDER_ASC,
    start_index: searchParams.get('start_index') ?? undefined,
    count: ROWS_PER_PAGE_DEFAULT,
    tariff_id: selectedTariffId ?? undefined
  })

  const selectedCatalogQueryParam = searchParams.get(SELECTED_CATALOG_PARAMETER_KEY) ?? undefined
  const [selectedCatalogId, setSelectedCatalogId] = useState(selectedCatalogQueryParam)

  const {
    data: { resources: catalogs } = { resources: [] },
    data: { total_results: totalResults } = { total_results: 0 },
    isFetching
  } = useGetCatalogsQuery(searchQueryParams)

  const setQueryParams = () => {
    Object.entries(searchQueryParams).forEach(([key, value]) => {
      if (value) {
        searchParams.set(key, value.toString())
      } else {
        searchParams.delete(key)
      }
    })

    // Set selectedCatalogId if it exists
    selectedCatalogId && searchParams.set(SELECTED_CATALOG_PARAMETER_KEY, selectedCatalogId)

    setSearchParams(searchParams)
  }

  useEffect(() => {
    setQueryParams()
  }, [searchQueryParams])

  useEffect(() => {
    if (selectedCatalogId) {
      setQueryParams()
    } else {
      searchParams.delete(SELECTED_CATALOG_PARAMETER_KEY)
      setSearchParams(searchParams)
    }
  }, [selectedCatalogId])

  return {
    catalogs,
    isFetching,
    searchQueryParams,
    setSearchQueryParams,
    totalResults,
    selectedCatalogId,
    setSelectedCatalogId
  }
}

export default useCatalogsWithParams
